module.exports = __webpack_public_path__ + "img/brochure.ed66f0b6.jpg";